export default __webpack_public_path__ + "static/media/11.cea90a40.jpg";